// extracted by mini-css-extract-plugin
export default {"root":"HeroImage-module-root","overlay":"HeroImage-module-overlay","content":"HeroImage-module-content"};